import { render, staticRenderFns } from "./NoSidebarLayout.vue?vue&type=template&id=03c1ffe6"
import script from "./NoSidebarLayout.vue?vue&type=script&lang=js"
export * from "./NoSidebarLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports